<template>
    <div class="hero__content" :class="{'hero__content--video' : hero_is_video}">
        <div class="hero_img_container" v-if="form_type === 'video'">
            <video autoplay muted loop class="hero__deco hero__deco--video" >
                <source :src="home_hero_desktop_video" type="video/mp4">
            </video>
        </div>
        <Flicking v-else-if="form_type === 'carousel'" :plugins="plugins" class="hero__deco hero__deco--carousel" ref="flicking"
                  :options="{defaultIndex: carouselStart, align: 'next', inputType:['mouse'], panelsPerView:1, circular: true, moveType: ['strict', { count: 1 }]}">
            <div v-for="(slide, slideKey) in home_hero_carousel_desktop_images" class="panel">
                <img :src="slide" :alt="home_hero_alt">
            </div>
            <span slot="viewport" class="flicking-arrow flicking-arrow-prev is-circle">
                <svg xmlns="http://www.w3.org/2000/svg" width="10.378" height="16"><path fill="none" fill-rule="evenodd" stroke="#FA5528" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9.377 1-7.99 6.21a1 1 0 0 0 0 1.58L9.376 15h0"/></svg>
            </span>
            <span slot="viewport" class="flicking-arrow flicking-arrow-next is-circle">
                <svg xmlns="http://www.w3.org/2000/svg" width="10.378" height="16"><path fill="none" fill-rule="evenodd" stroke="#FA5528" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 7.991 6.21a1 1 0 0 1 0 1.58L1 15h0"/></svg>
            </span>
        </Flicking>
        <img v-else class="hero__deco" :src="home_hero_desktop_image"
             :alt="home_hero_alt">
        <template v-if="has_composition_tag === 'true'">
            <div class="purple-circle-container">
                <div class="purple-circle">
                    <div class="deux-euro">
                        <h4>2 </h4>
                        <span>€</span>
                    </div>
                    <p>2 mois</p>
                </div>
            </div>
            <div class="orange-circle-container">
                <div class="orange-circle">
                    <p>offre <br> d’essai</p>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import image_mixin from "../../_commons/fr/mixins/image_mixin"

import {Flicking} from "@egjs/vue-flicking";
import "@egjs/vue-flicking/dist/flicking.css";

import {Arrow, AutoPlay} from "@egjs/flicking-plugins";
import "@egjs/flicking-plugins/dist/arrow.css";

export default {
    mixins: [
        image_mixin
    ],
    components: {
        Flicking
    },
    data() {
        return {
            plugins: [
                new Arrow({
                    parentEl: document.querySelector('.hero__content')
                }), new AutoPlay({ duration: 5000, direction: "NEXT", stopOnHover: false })
            ],
            carouselStart:0,
        }
    },
    created() {
        this.carouselStart = _.get(queryString.parse(location.search), 'carousel', 0);
    }
}
</script>

<style scoped>

</style>
